// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// GSAP + ScrollTrigger for scroll-driven animations
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(ScrollTrigger)

// Lenis for smooth scrolling
import Lenis from "lenis"

// Make GSAP available to Stimulus controllers
window.gsap = gsap
window.ScrollTrigger = ScrollTrigger
window.Lenis = Lenis
